const LayoutDefault = () =>
  import(/* webpackChunkName: "mitra-usaha" */ '@/layouts/LayoutDefault.vue');

const Jaringan = () =>
  import(
    /* webpackChunkName: "mitra-usaha" */ '@/views/member/jaringan/Index.vue'
  );

let root = '/jaringan';

export default [
  {
    path: root + '/',
    component: Jaringan,
    meta: {
      auth: true,
      title: 'Jaringan',
      layout: LayoutDefault,
    },
  }
];
